/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExperimentStatus } from '../models/ExperimentStatus';
import type { GetExperimentResponse } from '../models/GetExperimentResponse';
import type { GetExperimentsResponse } from '../models/GetExperimentsResponse';
import type { GetProductsSearchResponse } from '../models/GetProductsSearchResponse';
import type { GetTypesResponse } from '../models/GetTypesResponse';
import type { IDMessage } from '../models/IDMessage';
import type { PostExperimentRequest } from '../models/PostExperimentRequest';
import type { PutExperimentRequest } from '../models/PutExperimentRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ExperimentsService {

    /**
     * Read Meta
     * @returns GetTypesResponse Successful Response
     * @throws ApiError
     */
    public static readMetaV1ExperimentsMetaGet(): CancelablePromise<GetTypesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/experiments/meta',
        });
    }

    /**
     * Read Experiments
     * @param limit
     * @param offset
     * @param searchString
     * @param projectId
     * @param status
     * @returns GetExperimentsResponse Successful Response
     * @throws ApiError
     */
    public static readExperimentsV1ExperimentsGet(
        limit: number = 20,
        offset?: number,
        searchString?: (string | null),
        projectId?: string,
        status?: (ExperimentStatus | null),
    ): CancelablePromise<GetExperimentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/experiments/',
            query: {
                'limit': limit,
                'offset': offset,
                'search_string': searchString,
                'project_id': projectId,
                'status_': status,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Experiment
     * @param requestBody
     * @returns IDMessage Successful Response
     * @throws ApiError
     */
    public static createExperimentV1ExperimentsPost(
        requestBody: PostExperimentRequest,
    ): CancelablePromise<IDMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/experiments/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Manual Experiment
     * @param experimentId
     * @returns IDMessage Successful Response
     * @throws ApiError
     */
    public static createManualExperimentV1ExperimentsCreateManualExperimentPost(
        experimentId: string,
    ): CancelablePromise<IDMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/experiments/create_manual_experiment',
            query: {
                'experiment_id': experimentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Read Products
     * @param projectId
     * @param searchString
     * @param limit
     * @param offset
     * @returns GetProductsSearchResponse Successful Response
     * @throws ApiError
     */
    public static readProductsV1ExperimentsProductsGet(
        projectId: string,
        searchString?: (string | null),
        limit?: (number | null),
        offset?: (number | null),
    ): CancelablePromise<GetProductsSearchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/experiments/products',
            query: {
                'project_id': projectId,
                'search_string': searchString,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Generate Invitation Link
     * @param id
     * @param tasterId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static generateInvitationLinkV1ExperimentsIdInviteTasterIdPost(
        id: string,
        tasterId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/experiments/{id}/invite/{taster_id}',
            path: {
                'id': id,
                'taster_id': tasterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Read Anchors
     * @param id
     * @returns number Successful Response
     * @throws ApiError
     */
    public static readAnchorsV1ExperimentsIdAnchorsGet(
        id: string,
    ): CancelablePromise<Array<number>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/experiments/{id}/anchors',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Read Experiment
     * @param id
     * @param language
     * @returns GetExperimentResponse Successful Response
     * @throws ApiError
     */
    public static readExperimentV1ExperimentsIdGet(
        id: string,
        language?: string,
    ): CancelablePromise<GetExperimentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/experiments/{id}',
            path: {
                'id': id,
            },
            query: {
                'lang': language,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Experiment
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateExperimentV1ExperimentsIdPut(
        id: string,
        requestBody: PutExperimentRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/experiments/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Archive Experiment
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static archiveExperimentV1ExperimentsIdDelete(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/experiments/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Rank Experiment
     * @param id
     * @returns any Successful Response
     * @throws ApiError
     */
    public static rankExperimentV1ExperimentsIdRankExperimentGet(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/experiments/{id}/rank_experiment',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Experiment Insights
     * @param id
     * @returns any Successful Response
     * @throws ApiError
     */
    public static experimentInsightsV1ExperimentsIdExperimentInsightsGet(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/experiments/{id}/experiment_insights',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
